// Path to the axolotl GLB shipped from the Cute Axolotl asset pack.
//
// Drop the converted glTF/GLB file at:
//   apps/web/public/models/axolotl.glb
// and Vite will serve it from `/models/axolotl.glb`. If the file is
// missing the MascotCanvas falls back to a CSS sprite so the tutorial
// flow still works in dev environments without the licensed asset.
export const MASCOT_GLB_URL = "/models/axolotl.glb";
